<template>
	<div id="cert">
		<el-row :gutter="20" class="mb-20">
	    <el-col :xs="24" :sm="24" :lg="24">
	    	<el-card class="box-card">
	    		<el-form label-position="top"
	            :model="form"
	             ref="dataForm"
	             label-width="100px">
	          <el-row>

	          	<el-col :xs="24" :sm="24" :md="24" :lg="10" v-if="showCertImage">
	          		<el-form-item label="證書樣版圖" prop="certImage">
		              <UploadWidget fileLimit="profile.form.cert_limit" :uuid="form.certImage" usage="cert_image" @uploadSuccess="uploadSuccess" />
		            </el-form-item>
	          	</el-col>
	          	
	          	<el-col :xs="24" :sm="24" :md="24" :lg="14">
	          		<el-row>
	          			<el-col :xs="24" :sm="24" :md="24" :lg="10" class="pr-10">
			              <el-form-item label="證書編號" prop="courseCode">
			                <el-input v-model="form.courseCode" readOnly :disabled="true"></el-input>
			              </el-form-item>
			            </el-col>
			            <el-col :xs="24" :sm="24" :md="24" :lg="4" class="pr-10">
			              <el-form-item label="定位(上)" prop="certNoTop">
			                <el-input type="number" :min="95" v-model.number="form.certNoTop"></el-input>
			              </el-form-item>
			            </el-col>
			            <el-col :xs="24" :sm="24" :md="24" :lg="4">
			              <el-form-item label="定位(左)" prop="certNoLeft">
			                <el-input type="number"  v-model.number="form.certNoLeft"></el-input>
			              </el-form-item>
			            </el-col>
	          		</el-row>
	          		
	          		<el-row>
			          	<el-col :xs="24" :sm="24" :md="24" :lg="10" class="pr-10">
			              <el-form-item label="英文名" prop="studentEnName">
			                <el-input v-model="form.studentEnName" readOnly :disabled="true"></el-input>
			              </el-form-item>
			            </el-col>
			            <el-col :xs="24" :sm="24" :md="24" :lg="4" class="pr-10">
			              <el-form-item label="定位(上)" prop="enNameTop">
			                <el-input type="number"  v-model.number="form.enNameTop"></el-input>
			              </el-form-item>
			            </el-col>
			            <el-col :xs="24" :sm="24" :md="24" :lg="4">
			              <el-form-item label="定位(左)" prop="enNameLeft">
			                <el-input type="number"  v-model.number="form.enNameLeft"></el-input>
			              </el-form-item>
			            </el-col>
			          </el-row>

			          <el-row>
			          	<el-col :xs="24" :sm="24" :md="24" :lg="10" class="pr-10">
			              <el-form-item label="中文名" prop="studentChName">
			                <el-input v-model="form.studentChName" readOnly :disabled="true"></el-input>
			              </el-form-item>
			            </el-col>
			            <el-col :xs="24" :sm="24" :md="24" :lg="4" class="pr-10">
			              <el-form-item label="定位(上)" prop="chNameTop">
			                <el-input type="number"  v-model.number="form.chNameTop"></el-input>
			              </el-form-item>
			            </el-col>
			            <el-col :xs="24" :sm="24" :md="24" :lg="4" >
			              <el-form-item label="定位(左)" prop="chNameLeft">
			                <el-input type="number"  v-model.number="form.chNameLeft"></el-input>
			              </el-form-item>
			            </el-col>
			          </el-row>

          		</el-col>
          	</el-row>

          	<div class="text-right" v-if="showCertImage">
	            <el-button type="primary" @click="saveData('dataForm')">儲存資料</el-button>
	        	</div>
	        </el-form>
	    	</el-card>
	    </el-col>
	  </el-row>


<!-- 
		<el-row :gutter="20" >
	    <el-col :xs="24" :sm="24" :lg="24">
	    	<el-card class="box-card"> 
	    	-->
	      <div style="position: relative;">

	      	<div @click="generatePDF()" class="np-btn">預覽證書(pdf檔)</div>

				    <vue-html2pdf
				      :show-layout="false"
				      :float-layout="false"
				      :enable-download="false"
				      :preview-modal="true"
				      :paginate-elements-by-height="1000"
				      filename="cert"
				      :pdf-quality="5"
				      :manual-pagination="false"
				      pdf-format="a4"
				      :pdf-margin="10"
				      pdf-orientation="landscape"
				      @progress="onProgress($event)"
				      ref="html2Pdf"
				    >
				      <section slot="pdf-content">
				        <CertContent v-if="form" :form="form" />
				      </section>
				    </vue-html2pdf>

				    
				    <!-- <vue-html2pdf
				      :show-layout="false"
				      :float-layout="false"
				      :enable-download="false"
				      :preview-modal="true"
				      :paginate-elements-by-height="1000"
				      filename="cert"
				      :pdf-quality="5"
				      :manual-pagination="false"
				      pdf-format="a4"
				      :pdf-margin="10"
				      pdf-orientation="landscape"
				      @progress="onProgress($event)"
				      ref="html2Pdf"
				    >
				      <section slot="pdf-content">
				        <CertPrintContent v-if="form" :form="form"  />
				      </section>
				    </vue-html2pdf> -->
	     </div>
	     	<!-- 
	     		</el-card>
	     </el-col>
	   </el-row> -->
  </div>
</template>

<script>
import {mapState} from 'vuex'
import VueHtml2pdf from 'vue-html2pdf'
import CertContent from '@/views/courses/maintain/cert_content'
import CertPrintContent from '@/views/courses/maintain/cert_print_content'
import UploadWidget from '@/components/upload/'
import store from '@/store'


export default {
	name: 'CertInfo',
	components:{
		CertContent,VueHtml2pdf,CertPrintContent,UploadWidget
	},
	computed: {
    ...mapState('login', ['userInfo']),
  },
	props:{
		showCertImage: {
      type: Boolean,
      default: true
    }
	},
	data(){
		return {
			form: {
				courseCode:'',
				studentEnName:'',
				studentChName: '',
				studentId:'',
				id:'',
				certImg:'',
				certNoTop:0,
				certNoLeft:0,
				enNameTop:0,
				enNameLeft:0,
				chNameTop:0,
				chNameLeft:0,
				certImage:'',
				fileId:''
			}
		}
	},
	methods:{
		onProgress(event) {
      console.log(`Processed: ${event} / 100`);
    },
    hasGenerated() {
      alert("PDF generated successfully!");
    },
    generatePDF() {

    	this.request.post("/course", this.form).then(res => {
        if (res.code === '200') {
          const loading = this.$loading({
		          lock: true,
		          text: '生成證書中，請稍候...',
		          spinner: 'el-icon-loading',
		          background: 'rgba(0, 0, 0, 0.7)'
		        });

		      let query = {
		        courseId: this.form.id,
		        userId: store.state.login.userInfo.id
		      }
		      console.log('query:', query)
		     
		      this.request.get("/course/preview-student-cert", {params: query} ).then(res1 => {
		          if (res1.code === '200') {
		            loading.close();

		            let url = "/course/export-student-cert?courseId=" + this.form.id + "&userId=" + store.state.login.userInfo.id
		            window.open(process.env.VUE_APP_API_SERVER + url, "new")

		            
		          } else {
		            this.showResult('error', '生成證書出現錯誤')
		          }
		        })


        } else {
          // this.showResult('error', this.$t('action.save_error', {err: res.message}))
        }
      })

    	


    	
      // this.$refs.html2Pdf.generatePdf();

    },
    loadData(){
    	this.request.get("/course/"+this.form.id).then(res => {
        if (res.code === '200') {
          this.form = res.data

          if (!res.data.courseCode) { this.form.certNo = '00000' }
          if (!res.data.certNoTop) { this.form.certNoTop = 180 }
          if (!res.data.certNoLeft) { this.form.certNoLeft = 680 }

          if (!res.data.enNameTop) { this.form.enNameTop = 420 }
          if (!res.data.enNameLeft) { this.form.enNameLeft = 320 }

          if (!res.data.chNameTop) { this.form.chNameTop = 370 }
          if (!res.data.chNameLeft) { this.form.chNameLeft = 180 }


          if (store.state.login.userInfo.username) {
			    	this.form.studentChName = store.state.login.userInfo.username
			    }
			    if (store.state.login.userInfo.engName) {
			    	this.form.studentEnName = store.state.login.userInfo.engName
			    }

        } else {
          this.showResult('error', this.$t('action.get_error', {err: '無法取得課程資料'}))
        }
      })
    },
    saveData(){
    	this.request.post("/course", this.form).then(res => {
        if (res.code === '200') {
          // this.loadData()
          this.showResult('success', this.$t('action.save_success'))
        } else {
          this.showResult('error', this.$t('action.save_error', {err: res.message}))
        }
      })
    },
    uploadSuccess(file){
      // this.form.uploadNew = 'Y'
      this.form.certImage = file.uuid
      this.form.fileId = file.id
    },
	},
	mounted(){
		this.form.studentId = this.userInfo.id
		this.form.id = parseInt(this.$route.params.cid)
		this.loadData()
    // this.loadFeatureType()

    // console.log('user:', store.state.login.userInfo.username)
    // console.log('user eng:', store.state.login.userInfo.engName)

	}
}

</script>

<style scoped>
.np-btn {
  display: inline-block;
  padding: 6px 20px;
  margin: 12px 8px;
  border: 1px solid #da1010;
  background: #da1010;
  border-radius: 6px;
  color: #ffffff;
  cursor: pointer;
}

.box-card >>> .el-form--label-top .el-form-item__label {
	padding: 0;
}

</style>


